var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/phone_number/index.js
 ** module id = 856
 ** module chunks = 0
 **/